import React from 'react'

import {
  classnames, CrownFilled, CrownOne, Icon, ShapeHexagon, TagComponent,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

const premiumCrown = (
  <Icon
    svgComponent={CrownOne}
    className="subscription-tag__crown"
    color="extra-purple"
    notSpaced
  />
)

const CONFIG = {
  essentials: {
    color: 'primary',
    type: 'ghost',
    label: 'Essentials',
    leadIcon: null,
  },
  premium: {
    color: 'extra-purple',
    type: 'ghost',
    label: 'Premium',
    leadIcon: premiumCrown,
  },
}

const TIER_ICONS = {
  essentials: { svg: ShapeHexagon, size: { width: '12', height: '12' } },
  premium: { svg: CrownFilled, size: { width: '14', height: '14' } },
}

// The chip encodes the catalog a model is IN, so it renders only for models actually
// opted in to a subscription. An opted-in model whose price left the eligible band
// (tierBand null) must stay blank rather than fall open.
function SubscriptionStatusTag({
  itemId, subscriptionSubscribed = false, subscriptionTierBand = null, plansRestructureEnabled = false,
}) {
  if (!subscriptionSubscribed) return null

  const config = CONFIG[subscriptionTierBand]
  if (!config) return null

  const id = `subscription-tier-${subscriptionTierBand}-${itemId}`

  if (plansRestructureEnabled) {
    const icon = TIER_ICONS[subscriptionTierBand]

    return (
      <span
        id={id}
        className={classnames(
          'subscription-status-tag',
          `subscription-status-tag--${subscriptionTierBand}`,
          'cgt-caption-semibold'
        )}
      >
        <Icon
          svgComponent={icon.svg}
          size={icon.size}
          className="subscription-status-tag__icon"
          notSpaced
        />
        {config.label}
      </span>
    )
  }

  return (
    <TagComponent
      id={id}
      color={config.color}
      type={config.type}
      leadIcon={config.leadIcon}
      small
    >
      {config.label}
    </TagComponent>
  )
}

SubscriptionStatusTag.propTypes = {
  itemId: string.isRequired,
  subscriptionSubscribed: bool,
  subscriptionTierBand: string,
  plansRestructureEnabled: bool,
}

export default SubscriptionStatusTag
